export enum SubscriptionCancelReason {
  ByAdmin = 'BY_ADMIN',
  ByOwner = 'BY_OWNER',
  ByExpiredCard = 'BY_EXPIRED_CARD',
}
